import { AssignorAgents } from 'src/app/shared/models';
import { Representative } from 'src/app/shared/models/representative.model';

export function mapAssignorAgentToRepresentative(agent: AssignorAgents): Representative {
  return {
    nome: agent.nomeRepresentante,
    email: agent.email,
    tipoPessoa: agent.tipoPessoa,
    cpfcnpj: agent.cpfCnpj,
    telefone: agent.numeroTelefone,
    assina: agent.assina,
    assinaTermoCessao: agent.assinaTermoCessao,
    assinaEndosso: agent.assinaEndosso,
    emiteDuplicata: agent.emiteDuplicata,
  };
}
